import { z } from 'zod';
import { InspectionTypeDayOfWeekSchema } from '../inputTypeSchemas/InspectionTypeDayOfWeekSchema'
import { InspectionTypeMeridiemSchema } from '../inputTypeSchemas/InspectionTypeMeridiemSchema'

/////////////////////////////////////////
// INSPECTION TYPE BLOCK OUT DAY SCHEMA
/////////////////////////////////////////

export const InspectionTypeBlockOutDaySchema = z.object({
  day_of_week: InspectionTypeDayOfWeekSchema,
  meridiem: InspectionTypeMeridiemSchema.nullable(),
  id: z.bigint(),
  created_at: z.coerce.date(),
  inspection_type_id: z.bigint(),
})

export type InspectionTypeBlockOutDay = z.infer<typeof InspectionTypeBlockOutDaySchema>

export default InspectionTypeBlockOutDaySchema;
